import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "uk-padding uk-padding-remove-horizontal" }
const _hoisted_2 = { class: "uk-padding" }
const _hoisted_3 = { class: "uk-position-relative uk-visible-toggle uk-margin-small-top" }
const _hoisted_4 = {
  class: "uk-child-width-1-2@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-1@s data-uk-grid uk-grid-match uk-margin-large-bottom",
  "data-uk-grid": ""
}

import HeadingBloc from "@/views/booking/HeadingBloc.vue";
import BookingSearch from "@/views/booking/BookingSearch.vue";
import ApartmentItem from "@/views/booking/ApartmentItem.vue";
import CsaPagination from "@/components/CsaPagination.vue";
import {ref} from "vue";
import Room from "@/models/Room";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CsaApartments',
  setup(__props) {

const roomPaginate =ref<Room[]>([]);
const load = ref(true)
const updatePagination = (event:any)=>{
  load.value = true;
  console.log(event.data);
  roomPaginate.value = event.data.value;
  setTimeout(()=>{
    load.value = false
  },1000)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadingBloc),
    _createVNode(BookingSearch),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (load.value)
          ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomPaginate.value, (room, index) => {
              return (_openBlock(), _createBlock(ApartmentItem, {
                key: index,
                "room-item": room
              }, null, 8, ["room-item"]))
            }), 128))
          ]),
          _createVNode(CsaPagination, {
            "item-perp-page": 3,
            onDataPaginate: _cache[0] || (_cache[0] = ($event: any) => (updatePagination($event)))
          })
        ])
      ])
    ])
  ], 64))
}
}

})